/*-------------------------------------------------------------------------------

  オブザーバー

--------------------------------------------------------------------------------*/

export default class tccf7Observer {
  constructor( elem , callback ) {
    if( !elem ) return;
    this.elem             = elem;    
    this.observer         = null;
    this.callback         = callback; 

    const DEBOUNCE_WAIT = 200;
    this.debounceObserver = this.debounce(this.check.bind(this), DEBOUNCE_WAIT);
    this.init(); 
  }

  /*----------------------------------------
    初期化
  ------------------------------------------*/
  init() {
    this.observer = new MutationObserver(this.debounceObserver);
    const config = {
      childList: true, 
      subtree: true
    };
    this.observer.observe(this.elem, config);
  }

  /*----------------------------------------
    オブザーバーの内容
  ------------------------------------------*/
  check() {
    requestAnimationFrame(() => {
      if (typeof this.callback === "function") {
        this.callback();
      }
    });
  }
  
  /*----------------------------------------
    デバウンス関数
  ------------------------------------------*/
  /**
   * @param {Function} func 実行する関数
   * @param {number} wait 待機時間(ms)
   */
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  /*----------------------------------------
    インスタンス破棄：メモリリーク防止
  ------------------------------------------*/
  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}